/**
 * @file paddle Wave Summit 2020
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import { Anchor } from 'antd';
import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import useWaveSummitHooks from './waveSummitHooks';
import A from '../../components/a/A';
import ActiveList from './components/active-list/ActiveList';
import AwardsCeremony from './components/awards-ceremony/AwardsCeremony';
import Selection from './components/rules/rules';
import Shortlisteds from './components/shortlisted/Shortlisted'
import desc from './image/desc.png'
import rules from './image/rules.png'
import ways from './image/ways.png'
import sets from './image/sets.png'
import projects from './image/projects.png'
import related from './image/related.png'
import Link from 'antd/lib/typography/Link';
const WaveSummit: React.FC = () => {

    const {
        introduce,
        rulesdec,
        selection,
        activityParticipation,
        awardsCeremony,
        shortlisted
    } = useWaveSummitHooks();
    return (
        <div className="page paddle-ws2021-page">

            <Header />
            <div className="paddle-ws2021-banner">
                <div className="banner">
                    <div className="banner-button">
                        <div className="button-div" id="button">
                            
                            <a  className="button-a"  href="https://iwenjuan.baidu.com/?code=l32sbk">立即报名</a>
                            <a  className="button-a" href="https://github.com/Awesome-DeepLearning/WAVE_SUMMIT_Ranking_List">进入GitHub</a>
                        </div>
                    </div>

                </div>
            </div>
            <div className="all">
                <div className="height-d"></div>
                <div className="paddle-ws2021-nav">
                    <Anchor>
                        <div className="nav-list">
                            <Link >
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#活动简介"
                                >
                                    活动简介
                                </A>
                            </Link>
                            <Link >
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#评选规则"
                                >
                                    评选规则
                                </A>
                            </Link>
                            <Link >
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#参与方式"
                                >
                                    参与方式
                                </A>
                            </Link>
                            <Link >
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#奖项设置"
                                >
                                    奖项设置
                                </A>
                            </Link>
                            <Link >
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#入围项目"
                                >
                                    入围项目
                                </A>
                            </Link>
                            <Link>
                                <A
                                    className="paddle-ws2021-anchor"
                                    href="#补充说明"
                                >
                                    补充说明
                                </A>
                            </Link>
                        </div>
                    </Anchor>
                </div>
                <div className="paddle-ws2021-int" id='活动简介'>
                    <div className="int-all">
                        <img src={desc} alt="" />
                        <div className="introduce">
                            <div className="introduce-oue">
                            <div className="introduce-word" {...{ dangerouslySetInnerHTML: { __html: introduce } }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="paddle-ws2021-rules" id='评选规则'>
                    <div className="rules">
                        <img src={rules} alt="" />
                        <div className="rules-desc">
                            
                            <div className="rulesdec">
                                <div className="rulesdec-word" {...{ dangerouslySetInnerHTML: { __html: rulesdec } }}/>
                            </div>
                            <div className="zhanwei"></div>
                            <Selection {...selection} />
                        </div>
                    </div>
                </div>
                <div className="paddle-ws2021-ways" id='参与方式'>
                    <div className="ways">
                        <img className="img-ways" src={ways} alt="" />
                        <div className="ways-desc">
                            <ActiveList {...activityParticipation} />

                        </div>
                    </div>
                </div>
                <div className="paddle-ws2021-sets" id='奖项设置'>
                    <div className="sets">
                        <img src={sets} alt="" />
                        <div className="sets-desc">
                            <AwardsCeremony {...awardsCeremony} />
                        </div>
                    </div>
                </div>
                <div className="paddle-ws2021-projects" id='入围项目'>
                    <div className="projects">
                        <img src={projects} alt="" />
                        <div className="projects-desc">
                            <Shortlisteds  {...shortlisted} />

                        </div>
                    </div>
                </div>
                <div className="paddle-ws2021-related" id='补充说明'>
                    <div className="related">
                        <img src={related} alt="" />
                        <div className="related-desc">

                            <p className="desc-top">本次征集活动面向所有在GitHub中公开且项目中包含飞桨任一组件的开源项目，具体规则如下:</p>
                            <ol>
                                <li>项目在GitHub中处于更新状态或已经可以正常使用。</li>
                                <li>代码中包含的飞桨PaddlePaddle核心框架版本号需高于2.0。</li>
                                <li>禁止参与者注册多账户/报名，不可借助购买Star、刷Commit等手段来破坏开源社区生态，发现即清空个人积分。</li>
                                <li>优秀的开源项目往往靠的是长期积累而非短期刷量，为更好评估分数，形如Commit、Contributor、Issue、Fork的相关统计在活动开始后会对新增加的数据进行人工降权，活动开始前所积累的数据则不受任何影响。</li>
                                <li>项目中使用飞桨组件且不包含暴力、赌博、政治等危害社会公共安全内容。</li>
                                <li>在法律允许的范围内最终解释权归飞桨所有。</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="foot">
                    <div className="null"></div>
                    <li>大会咨询请联系：paddle-up@baidu.com 获取帮助</li>
                    <li>版权所有 2021 深度学习技术及应用国家工程实验室 京ICP备20012337号-1</li>
                </div>
            </div>
            <Footer />

        </div>



    );
};

export default React.memo(WaveSummit);
